import { render } from "./ControlPanel.vue?vue&type=template&id=5f1e7fac&scoped=true&ts=true"
import script from "./ControlPanel.vue?vue&type=script&lang=ts"
export * from "./ControlPanel.vue?vue&type=script&lang=ts"

import "./ControlPanel.vue?vue&type=style&index=0&id=5f1e7fac&scoped=true&lang=css"

import exportComponent from "/vue/cubetrain/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1e7fac"]])

export default __exports__